<template>
  <div>其他表单类型 {{item}}</div>
</template>

<script>
export default {
    name : 'MobileTicketTaskFormItem',

    props: ['item', 'value', 'mode']
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/mobile-ticket/MobileTicketTaskFormItem.vue